import DashboardVM from './dashboard-vm'
import Vue from 'vue'

export default {
  init: function(container) {
    const vm = new Vue(DashboardVM)
    vm.bindData(JSON.parse(container.dataset.dashboardJson))
    vm.$mount(container)
  }
}
